import { useMutation } from '@tanstack/react-query';

export const useCheckUsernameSignup = () => {
  return useMutation({
    mutationFn: async (username) => {
      const API_URL = process.env.REACT_APP_API_URL;
      const fullUrl = `${API_URL}/api/auth/check-username?username=${encodeURIComponent(username)}`;
      
      try {
        const response = await fetch(fullUrl, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        const contentType = response.headers.get('content-type');
        const isJSON = contentType && contentType.includes('application/json');

        if (!isJSON) {
          throw new Error(
            `Server returned ${response.status}: Expected JSON but got ${contentType || 'unknown'}`
          );
        }

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || `HTTP ${response.status}`);
        }

        return data; 
      } catch (error) {
        throw error; 
      }
    }
  });
};